import { useQuery } from "react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useFetchVesselPrimaryInformation = (vesselId) => {
  const { token } = useContext(AuthContext);

  const fetchVesselPrimaryInformation = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/vessel/primaryInformation/${vesselId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      if (response.data.status !== "success") {
        throw new Error(response.data.message || "Failed to fetch vessel primary information");
      }

      return response.data;
    } catch (error) {
      throw error;
    }
  };

  return useQuery(["vesselPrimaryInformation", vesselId], fetchVesselPrimaryInformation);
};

export default useFetchVesselPrimaryInformation;
